import React, { useEffect, useRef, useState } from 'react'
import SignaturePad from 'react-signature-canvas'
import { 
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap'

import './index.scss'

const TestDrawingBoard = props => {
  let temp = window.location.hash.split(/[/,]+/)

  const canvasRef = useRef(null);
  const [ signedImage, setSignedImage ] = useState( '' )
  if (canvasRef.current) {
    // this will get the canvas HTML element where everyhting that's painted is drawn
    // and call the toDataURL() function on it
  }

  useEffect( () => {
    if ( !props.open ) {
      setSignedImage( '' )
    }
  }, [ props.open ])

  const renderTitle = () => {
    switch(props.formType) {
      case 1:
        return 'Sign Confirmation Form'
      case 2:
        return 'Sign Refund Form'
      case 3:
        return 'Sign Appointment Letter'
      case 4:
        return 'Sign Authorisation Form'
      default:
        return `Sign ${ temp[1]} form`
    }
  }
  
  return (
    <Modal    
      centered={ true }
      scrollable={ true }
      size={ 'lg' }
      className='at-profile__digital-canvas'
      isOpen={ props.open }>
      <ModalHeader toggle={ () => props.updateShowSignBox( false )}>{ renderTitle() }</ModalHeader>
      <ModalBody className={ 'at-profile__digital-canvas-content' }>
        <SignaturePad 
          canvasProps={{ className: 'h-100 w-100' }}
          ref={ canvasRef }
          onEnd={ () => {
            setSignedImage( canvasRef.current.getCanvas().toDataURL() )
          }}
        />
      </ModalBody>
      <ModalFooter className={ 'd-flex justify-content-start' }>
        <button 
          disabled={ signedImage === '' }
          className="btn btn-primary"
          onClick={() => {
            props.signedImage( signedImage )
          }}>Adopt</button>
        <button 
          disabled={ signedImage === '' }
          className="btn btn-outline-secondary"
          onClick={() => {
            setSignedImage( '' )
            canvasRef.current.clear()
          }}>Clear</button>
      </ModalFooter>
    </Modal> 
  )
}

export default TestDrawingBoard